import React, { forwardRef, useImperativeHandle } from 'react';
import { Box } from '@mui/material';

const Wizard = forwardRef(
  (
    {
      steps = [],
      activeStep = 0,
      onStepChange,
      orientation = 'horizontal',
      sx,
    },
    ref,
  ) => {
    useImperativeHandle(ref, () => ({
      next: () => {
        if (activeStep < steps.length - 1) {
          onStepChange(activeStep + 1);
        }
      },

      previous: () => {
        if (activeStep > 0) {
          onStepChange(activeStep - 1);
        }
      },

      goToStep: step => {
        if (step >= 0 && step < steps.length) {
          onStepChange(step);
        }
      },

      first: () => {
        onStepChange(0);
      },

      last: () => {
        onStepChange(steps.length - 1);
      },

      reset: () => {
        onStepChange(0);
      },

      isFirst: () => activeStep === 0,

      isLast: () => activeStep === steps.length - 1,

      getCurrentStep: () => activeStep,
    }));

    if (!steps || (Array.isArray(steps) && steps.length === 0)) {
      return null;
    }

    return (
      <Box sx={sx}>
        {orientation === 'horizontal' && (
          <Box sx={{ mt: 4 }}>{steps[activeStep]?.component}</Box>
        )}
      </Box>
    );
  },
);

Wizard.displayName = 'Wizard';

export default Wizard;
